import { TipoProjeto } from "../services/tiposProjeto";
import { corContraste } from "./TagChip";
import { iniciaisProjeto } from "./ProjetoAvatar";
import { anexoUrlAbsoluto } from "../services/tarefas";

/**
 * Chip representando um projeto vinculado a uma tarefa. Quando `nome` for
 * informado, mostra as INICIAIS do nome (ex.: "Mococa em Foco" → "MF") como
 * prefixo — substituindo o antigo emoji 📁/💻 do tipo. Se houver `fotoUrl`,
 * a imagem do projeto entra no lugar das iniciais.
 *
 * Sem `nome` (uso histórico em telas de configuração de tipo), mantém o emoji
 * do tipo. O background segue a cor do tipo de projeto.
 */
export function TipoProjetoChip({ tipo, nome, fotoUrl, tamanho = "sm" }: {
  tipo: TipoProjeto | undefined;
  nome?: string;
  fotoUrl?: string | null;
  tamanho?: "xs" | "sm";
}) {
  const cor = tipo?.cor || "#64748b";  // slate-500 fallback
  const txt = corContraste(cor);
  const corTxt = txt === "white" ? "#fff" : "#0f172a";

  const padding = tamanho === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  const avatarSize = tamanho === "xs" ? "w-3.5 h-3.5 text-[8px]" : "w-4 h-4 text-[9px]";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded font-medium ${padding} max-w-full`}
      style={{ background: cor, color: corTxt }}
      title={tipo ? `${tipo.label}${nome ? ` · ${nome}` : ""}` : nome}
    >
      {nome ? (
        fotoUrl ? (
          <img
            src={anexoUrlAbsoluto(fotoUrl)}
            alt=""
            className={`${avatarSize} rounded object-cover shrink-0`}
          />
        ) : (
          <span
            className={`${avatarSize} rounded inline-flex items-center justify-center font-bold leading-none shrink-0`}
            style={{ background: "rgba(255,255,255,.25)", color: corTxt }}
          >
            {iniciaisProjeto(nome)}
          </span>
        )
      ) : (
        <span className="leading-none shrink-0">{tipo?.icone || "📁"}</span>
      )}
      {nome && <span className="truncate">{nome}</span>}
    </span>
  );
}
